import getEnumTranslation from './enums'

export function getEnumItems (localize, { enumName, values }) {
  return values.map(value => ({ value, text: getEnumTranslation({ localize, enumName, value }) }))
}



// WEBPACK FOOTER //
// ./src/enums/getEnumItems.js